import React from 'react';
import { Checkbox, Typography, Paper, useTheme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withDeletePopup from '../../withDeletePopup';
import { useEventCallback } from '../../../helpers/hooks';
import { AddItemDialog } from './AddItemDialog';
import { EventNoteOutlined as EventNoteOutlinedIcon } from '@mui/icons-material';
import { getTaskItemTitle } from '../../../helpers/event-helper';

const useStyles = makeStyles(theme => ({
  itemRow: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    backgroundColor: theme.palette.grey[300],
    borderRadius: 0,
    '&:before': {
      position: 'absolute',
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: theme.palette.divider,
    },
  },
  itemTitle: {
    display: 'block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '90%',
    cursor: 'pointer',
    flexGrow: 1,
  },
  itemCheckbox: {
    padding: 0,
    marginRight: theme.spacing(1),
  },
  noteIcon: {
    marginRight: theme.spacing(1),
  },
  removePreflightNote: {
    marginRight: theme.spacing(2),
  },
}));

const ListItem = ({
  item,
  index,
  setFieldValue,
  name,
  onEdit,
  onDelete,
  onDeleteConfirmationDialogOpen,
  mode,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const [isEditingItem, setIsEditingItem] = React.useState(false);

  const handleCompleteClick = useEventCallback(() => {
    setFieldValue(`${name}[${index}].isCompleted`, !item.isCompleted);
  });

  const handleDeleteClick = useEventCallback(() =>
    onDeleteConfirmationDialogOpen(() => onDelete(index))
  );

  return (
    <>
      <Paper
        className={classes.itemRow}
        elevation={1}
        onClick={() => {
          setIsEditingItem(true);
        }}
      >
        {mode === 'task' && (
          <Checkbox
            className={classes.itemCheckbox}
            style={{
              color: !item.isCompleted ? theme.palette.error.main : 'inherit',
            }}
            color="primary"
            checked={item.isCompleted}
            onChange={handleCompleteClick}
            onClick={event => event.stopPropagation()}
          />
        )}

        {mode === 'note' && (
          <EventNoteOutlinedIcon className={classes.noteIcon} />
        )}

        <Typography
          className={classes.itemTitle}
          onClick={() => {
            setIsEditingItem(true);
          }}
        >
          {getTaskItemTitle(item.description)}
        </Typography>
      </Paper>
      <AddItemDialog
        isOpen={isEditingItem}
        onItemEdit={onEdit}
        onClose={() => setIsEditingItem(false)}
        item={item}
        onDelete={handleDeleteClick}
        mode={mode}
      />
    </>
  );
};

export default React.memo(withDeletePopup(ListItem));
